<template>
    <router-link :class="['nft-tile', { 'nft-tile--disabled': isPartnerApp }]"
        :to="{
            name: 'digitalCollectiblesDetails',
            params: {
                collectibleId: nft.collectibleId,
            } }"
        :style="{
            ...(nft.partnerBackground ? {
                backgroundImage: ` linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url('${nft.partnerBackground}')`,
                backgroundSize: 'cover',
            } : {
                background: `linear-gradient(${nft.backgroundColor} 0%, #fff 150%)`
            })}"
    >
        <img :src="blockchainIconPath"
            alt="Blockchain Icon"
            class="blockchain-icon"
        >
        <nft-display class="nft-tile__logo"
            :show-placeholder="true"
            :url="getNftUrl"
            :isVideo="isVideo"
        />

        <div class="flex flex--column nft-infos">
            <div class="nft-infos__title">{{ nft.name }}</div>
            <label class="nft-infos__description">{{ nft.description }}</label>
        </div>
    </router-link>
</template>

<script>

// Components
import nftDisplay from '@webapp/modules/crypto-and-trading/views/nft/nft-display.vue';

// Vuex
import {
    mapGetters,
} from 'vuex';

export default {
    name: 'nft-tile',
    components: {
        nftDisplay,
    },
    props: {
        nft: {
            type: Object,
            required: true,
        },
        displayVideo: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters(['isPartnerApp']),

        blockchainIconPath() {
            return this.nft.networkType ? require(`@webapp/assets/${this.nft.networkType}.svg`) : '';
        },

        getNftUrl() {
            return this.displayVideo ? this.nft.animationUrl || this.nft.imageUrl : this.nft.imageUrl;
        },

        isVideo() {
            return this.nft.animationUrl !== '' && this.displayVideo;
        },
    },
};
</script>

<style lang="scss" scoped>
.nft-tile {
    position: relative;
    border-radius: 2rem;
    box-shadow: 0 1rem 1rem 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;

    &--disabled {
        pointer-events: none;
    }

    &__logo {
        height: 17rem;
        padding: 1rem 0;
        justify-content: center;
        align-items: center;
        align-self: center;
    }
}

.nft-infos {
    border-radius: 0 0 2rem 2rem;
    padding: 0.56rem 0.8rem 1rem;
    background-color: $snow-color;

    &__title {
        font-size: 1.5rem;
        font-weight: 700;
        @include line-clamp(1);
    }

    &__description {
        font-size: 1rem;
        @include line-clamp(1);
    }
}

.blockchain-icon {
    position: absolute;
    top: 12px;
    left: 19px;
    z-index: 3;
}
</style>